
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[...section]",
      function () {
        return require("private-next-pages/search/[...section].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[...section]"])
      });
    }
  